import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import _debounce from 'lodash/debounce';
import { Checkbox, InverseButton, PrimaryButton } from '@crehana/ui';
import { DEFAULT_IDLE_TIME, NOTIFICATION_AUDIO_URL } from "../constants";
import { usePlaybackContext } from "../context/Playback";
import { useResponsiveContext } from "../context/Responsive";
import { useTranslation } from "../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IdleScreen = function IdleScreen(_ref) {
  var inactivity = _ref.inactivity;
  var _useResponsiveContext = useResponsiveContext(),
    playerSize = _useResponsiveContext.playerSize;
  var _usePlaybackContext = usePlaybackContext(),
    visibleIdleScreen = _usePlaybackContext.visibleIdleScreen,
    onIdleChange = _usePlaybackContext.onIdleChange,
    ignoreInactivity = _usePlaybackContext.ignoreInactivity,
    toggleIgnoreInactivity = _usePlaybackContext.toggleIgnoreInactivity;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    idleTimeout = _useState2[0],
    setIdleTimeout = _useState2[1];
  useEffect(function () {
    var onMove = _debounce(function () {
      onIdleChange(false);
      if (idleTimeout) {
        clearTimeout(idleTimeout);
      }
      setIdleTimeout(function (prevTimeout) {
        if (prevTimeout) {
          clearTimeout(prevTimeout);
        }
        return setTimeout(function () {
          onIdleChange(true);
        }, (inactivity === null || inactivity === void 0 ? void 0 : inactivity.inactiveTime) || DEFAULT_IDLE_TIME);
      });
    }, 500);
    if (typeof window !== 'undefined') {
      if (ignoreInactivity) {
        window.removeEventListener('mousemove', onMove);
        window.removeEventListener('mousedown', onMove);
        window.removeEventListener('touchstart', onMove);
        window.removeEventListener('touchmove', onMove);
      } else {
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mousedown', onMove);
        window.addEventListener('touchstart', onMove);
        window.addEventListener('touchmove', onMove);
      }
    }
    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('mousemove', onMove);
        window.removeEventListener('mousedown', onMove);
        window.removeEventListener('touchstart', onMove);
        window.removeEventListener('touchmove', onMove);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ignoreInactivity]);
  useEffect(function () {
    _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _inactivity$onShown;
      var audio;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (visibleIdleScreen) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            inactivity === null || inactivity === void 0 ? void 0 : (_inactivity$onShown = inactivity.onShown) === null || _inactivity$onShown === void 0 ? void 0 : _inactivity$onShown.call(inactivity);
            audio = new Audio(NOTIFICATION_AUDIO_URL);
            _context.prev = 4;
            _context.next = 7;
            return audio.play();
          case 7:
            _context.next = 11;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](4);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 9]]);
    }))();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visibleIdleScreen]);
  var onPlay = function onPlay() {
    onIdleChange(false);
    if (inactivity && inactivity.onAction) {
      inactivity.onAction({
        action: 'play-next',
        ignoreChecked: ignoreInactivity
      });
    }
  };
  var onRestart = function onRestart() {
    onIdleChange(false);
    if (inactivity && inactivity.onAction) {
      inactivity.onAction({
        action: 'replay-module',
        ignoreChecked: ignoreInactivity
      });
    }
  };
  return /*#__PURE__*/_jsx("div", {
    className: "cp-idle-screen absolute inset-0 flex items-center justify-center bg-base-main-80 z-5 ".concat(visibleIdleScreen ? 'cui-is-visible' : 'cui-is-hidden'),
    children: playerSize.matches.sm ? /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col items-center text-center",
      children: [/*#__PURE__*/_jsx("h2", {
        className: "font-h1 text-white mb-32",
        children: t('IDLESCREEN_TITLE')
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex items-center justify-center mb-48",
        children: [/*#__PURE__*/_jsx(InverseButton, {
          label: t('IDLESCREEN_GO_BACK'),
          size: "l",
          isDark: true,
          isWhite: true,
          onClick: onRestart
        }), /*#__PURE__*/_jsx(PrimaryButton, {
          className: "ml-24",
          label: t('IDLESCREEN_CONTINUE'),
          size: "l",
          isDark: true,
          onClick: onPlay
        })]
      }), /*#__PURE__*/_jsx(Checkbox, {
        label: t('IDLESCREEN_IGNORE'),
        checked: ignoreInactivity
        // @ts-expect-error ('checked' does not exist in type HTMLAttributes<HTMLInputElement>)
        ,
        inputProps: {
          checked: ignoreInactivity
        },
        onChange: toggleIgnoreInactivity,
        isDark: true
      })]
    }) : /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col text-center px-24",
      children: [/*#__PURE__*/_jsx("h2", {
        className: "font-h2 text-white mb-24",
        children: t('IDLESCREEN_TITLE')
      }), /*#__PURE__*/_jsx(PrimaryButton, {
        className: "mb-16",
        label: t('IDLESCREEN_CONTINUE'),
        size: "xs",
        isDark: true,
        onClick: onPlay
      }), /*#__PURE__*/_jsx(InverseButton, {
        label: t('IDLESCREEN_GO_BACK'),
        size: "xs",
        isDark: true,
        isWhite: true,
        onClick: onRestart
      })]
    })
  });
};
export default IdleScreen;